import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { LoaderSpinnerTypes } from '@carm/_core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { ITempImportResponse, ITempImpVendorListResponse, ITempImpVendorResponse,
         ITempImpGoodListResponse, ITempImpGoodBase, ITempImpDraftHeaderResponse } from '../models/api/temporary-importation-api.model';

@Injectable()
export class TemporaryImportationService extends BaseApiService {
  get temporaryImportation(): string {
    return `${this.endPointBP}/cad/temporary-importation`;
  }

  public getSubmittedTempImport(
    headerUid: string
  ): Observable<ITempImportResponse> {
    const endPoint = `${this.temporaryImportation}/${headerUid}`;
    return this.httpAuthGet<ITempImportResponse>(endPoint);
  }

  constructor(protected injector: Injector) {
    super(injector);
  }

  public getVendorList(
    headerUid: string,
    searchString: string,
    sort: string,
    currentPage: number,
    pageSize: number
  ): Observable<ITempImpVendorListResponse> {
    const params = new HttpParams()
      .set('currentPage', currentPage.toString())
      .set('pageSize', pageSize.toString())
      .set('sort', sort)
      .set('searchString', searchString);
    const endPoint = `${this.temporaryImportation}/${headerUid}/vendors`;
    return this.httpAuthGet<ITempImpVendorListResponse>(endPoint, params, LoaderSpinnerTypes.AgGrid);
  }

  public getVendor(
    vendorUid: string
  ): Observable<ITempImpVendorResponse> {
    const endPoint = `${this.temporaryImportation}/vendor/${vendorUid}`;
    return this.httpAuthGet<ITempImpVendorResponse>(endPoint, null);
  }

  public getGoodsList(
    headerUid: string,
    vendorUid: string,
    searchString: string,
    sort: string,
    currentPage: number,
    pageSize: number
  ): Observable<ITempImpGoodListResponse> {
    const params = new HttpParams()
      .set('currentPage', currentPage.toString())
      .set('pageSize', pageSize.toString())
      .set('sort', sort)
      .set('searchString', searchString);
    const vendorUrl = `${this.temporaryImportation}/${headerUid}/vendor/${vendorUid}/goods`;
    return this.httpAuthGet<ITempImpGoodListResponse>(vendorUrl, params, LoaderSpinnerTypes.AgGrid);
  }

  public getGood(goodUid: string): Observable<ITempImpGoodBase> {
    const endPoint = `${this.temporaryImportation}/good/${goodUid}`;
    return this.httpAuthGet<ITempImpGoodBase>(endPoint, null);
  }

  public editTempImport(
    headerUid: string
  ): Observable<ITempImpDraftHeaderResponse> {
    const endPoint = `${this.temporaryImportation}/edit-submitted/${headerUid}`;
    return this.httpAuthPut<ITempImpDraftHeaderResponse>(endPoint, null);
  }

  public downloadTempImport(headerUid: string): Observable<Blob> {
    const endPoint = `${this.temporaryImportation}/${headerUid}/pdf`;
    return this.httpAuthDownloadFile(endPoint);
  }
}
